import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/heji", label: "合集总览" },
  { to: "/heji?cat=mingchang", label: "名场面补档" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/heji?q=${encodeURIComponent(q)}`);
    setKeyword("");
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden md:block bg-primary-600 text-background-50">
        <div className="mx-auto flex max-w-[1280px] items-center gap-3 px-6 py-2 text-xs">
          <span className="flex items-center gap-1.5 font-medium">
            <i className="ri-fire-fill text-sm"></i>
            今日热榜
          </span>
          <span className="h-3 w-px bg-background-50/40"></span>
          <p className="truncate text-background-50/90">
            实时热议 · 一条深夜动态发出又删除，截图已被存了三千遍
          </p>
        </div>
      </div>

      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 backdrop-blur"
            : "border-transparent bg-background-50"
        }`}
      >
        <nav className="mx-auto flex max-w-[1280px] items-center justify-between gap-4 px-4 py-3 md:px-6 md:py-4">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
              <i className="ri-chat-smile-2-line text-2xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display text-2xl tracking-wide text-foreground-950">
                蝌蚪吃瓜
              </span>
              <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">
                TADPOLE&nbsp;GOSSIP
              </span>
            </span>
          </Link>

          <ul className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => {
              const active =
                link.to === "/"
                  ? location.pathname === "/"
                  : location.pathname + location.search === link.to ||
                    (link.to === "/heji" && location.pathname === "/heji");
              return (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className={`rounded-md px-3 py-2 text-sm transition-colors whitespace-nowrap ${
                      active
                        ? "bg-primary-100 text-primary-700"
                        : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                    }`}
                  >
                    {link.label}
                  </Link>
                </li>
              );
            })}
          </ul>

          <div className="flex items-center gap-2">
            <form
              onSubmit={handleSearch}
              className="hidden items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 md:flex"
            >
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索合集 / 考古话题"
                className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </form>
            <Link
              to="/heji"
              className="hidden rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-block whitespace-nowrap"
            >
              开始补课
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-900 lg:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </nav>

        {open && (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <ul className="mx-auto flex max-w-[1280px] flex-col px-4 py-2">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="block rounded-md px-3 py-3 text-sm text-foreground-800 hover:bg-background-100"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <form onSubmit={handleSearch} className="mx-4 mb-4 flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索合集 / 考古话题"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </form>
          </div>
        )}
      </div>
    </header>
  );
}